import React from "react";
import CoinIcon from "../../../assets/images/coin-icon.png";
import PayWallet from "../../../assets/images/icon-wallet.png";
import { Link } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";

import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const profileContent = () => {
  return (

    <div className="main-content-left">
      <div className="top-content">
        <div className="left-content">
          <div class="Digant-Bhatt">Digant Bhatt</div>
          <div>9974920002</div>
          <div class="bhattdigantgmailcom">bhatt.digant@gmail.com</div>
        </div>

        <div className="right-icon-content">
          <PersonIcon className="person-icon" />
        </div>
      </div>

      <div className="bottom-content">
        <div className="main-items-booking ">
          <Link to="/documentupload" className="item-left">
            {" "}
            Profile Documents
          </Link>

          <div className="profile-icn">
            <CloseIcon style={{ color: " red" }} />
          </div>
        </div>

        <div className="main-items-booking ">
          <Link to="" className="item-left">
            Mobile Number
          </Link>

          <div className="profile-icn">
            <DoneIcon style={{ color: " green" }} />
          </div>
        </div>

        {/* <div className="main-items-booking ">
          <Link to="" className="item-left">
            paytm Wallet
          </Link>

          <div className="profile-icn">
            <CloseIcon style={{ color: " red" }} />
          </div>
        </div> */}

        {/* <div
          className="main-items-booking px-3 "
          style={{ background: "#d6dce2" }}
        >
          <Link to="/credits" className="item-left credits ">
            <img src={CoinIcon} alt="coin-icon" />
            Credits
          </Link>

          <div className="profile-icn">
            <span> ₹0</span>
          </div>
        </div> */}

        {/* <div
          className="main-items-booking mt-1 px-3  "
          style={{ background: "#d6dce2" }}
        >
          <Link to="" className="item-left">
            <img src={PayWallet} alt="coin-icon" />
            Paytm Wallet
          </Link>
          <Link to="" className="link-wallet">
            Link wallet
          </Link>
          <div className="profile-icn">div wallet</div>
        </div> */}
        <div className="main-items-booking ">
          <Link to="/mybooking" className="item-left">
            My Bookings
          </Link>

          <div className="item-right">
            <ArrowForwardIcon className="arrow-icon" />
          </div>
        </div>
        {/* <div className="main-items-booking ">
          <Link to="/savedcard" className="item-left">
            Saved Cards
          </Link>

          <div className="item-right">
            <img src={SaveCard} alt="coin-icon" />
          </div>
        </div> */}
        <div className="main-items-booking ">
          <Link to="/myaccount" className="item-left">
            Account
          </Link>

          <div className="item-right">
            {/* <img src={Account} alt="coin-icon" /> */}
          </div>
        </div>
        <div className="main-items-booking co-driver ">
          <Link to="/codriver" className="item-left">
            Co-Driver 
          </Link>

          <div className="item-right">
            {/* <img src={CoDriver} alt="coin-icon" /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default profileContent;
